"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isComboMultiday = isComboMultiday;
function isComboMultiday(comboType) {
    return ["CleanMultiday", "PersonalMultiday"].includes(comboType ?? "");
}
//# sourceMappingURL=isComboMultiday.js.map